import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { captureUtm } from "@/lib/utm";
import { trackCallClick, trackSmsClick } from "@/lib/track";

captureUtm();
// Count every call / text tap site-wide as a GA4 event (used for lead reports and Ads conversions).
document.addEventListener("click", (e) => {
  const a = e.target.closest && e.target.closest('a[href^="tel:"], a[href^="sms:"]');
  if (a) a.href.startsWith("tel:") ? trackCallClick(window.location.pathname) : trackSmsClick(window.location.pathname);
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
// Bot traffic gets a prerendered snapshot whose <head> already holds the page's title/meta/canonical.
// React re-adds them on mount, so drop the snapshot copies first to avoid duplicate tags.
document.head
  .querySelectorAll(
    'title, meta[name="description"], link[rel="canonical"], meta[property="og:title"], meta[property="og:description"],' +
      ' meta[property="og:type"], meta[property="og:url"], meta[name="twitter:title"], meta[name="twitter:description"],' +
      ' script[type="application/ld+json"]:not([data-static])',
  )
  .forEach((el) => el.remove());
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
